import { render } from "./CacheUsageDetails.vue?vue&type=template&id=09481a26&scoped=true"
import script from "./CacheUsageDetails.vue?vue&type=script&lang=js"
export * from "./CacheUsageDetails.vue?vue&type=script&lang=js"

import "./CacheUsageDetails.vue?vue&type=style&index=0&id=09481a26&lang=scss&scoped=true"

import exportComponent from "/builds/flowberry1/flowberry/user-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09481a26"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QTd from 'quasar/src/components/table/QTd.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QTable,QInput,QIcon,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QTd});qInstall(script, 'directives', {ClosePopup});
